import { z } from "zod";

export const createWarehouseExitSchema = z.object({
  documentNumber: z.string(),
  publicationDate: z.date(),
  note: z.string().optional(),
  quantity: z.string(),
});

export type CreateWarehouseExit = z.infer<typeof createWarehouseExitSchema>;
